import { Link } from "react-router-dom";

const entries = [
  {
    to: "/category/movie",
    label: "电影",
    icon: "ri-film-line",
    desc: "院线新片、类型佳片与高分推荐，一次看全",
    accent: "bg-accent-100 text-accent-700",
  },
  {
    to: "/category/tv",
    label: "电视剧",
    icon: "ri-tv-2-line",
    desc: "国产剧、美剧、日剧剧情介绍与追剧指南",
    accent: "bg-secondary-100 text-secondary-700",
  },
  {
    to: "/category/variety",
    label: "综艺",
    icon: "ri-mic-line",
    desc: "热门综艺看点、嘉宾阵容与更新动态",
    accent: "bg-primary-100 text-primary-700",
  },
];

export default function CategoryEntries() {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
      {entries.map((entry) => (
        <Link
          key={entry.to}
          to={entry.to}
          className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
        >
          <span
            className={`flex h-12 w-12 flex-none items-center justify-center rounded-lg ${entry.accent}`}
            aria-hidden="true"
          >
            <i className={`${entry.icon} text-2xl`} />
          </span>
          <span className="flex-1">
            <span className="flex items-center gap-1.5 text-base font-bold text-foreground-950">
              {entry.label}
              <i
                className="ri-arrow-right-line text-sm text-primary-500 transition-transform group-hover:translate-x-0.5"
                aria-hidden="true"
              />
            </span>
            <span className="mt-1 block text-xs leading-relaxed text-foreground-600">{entry.desc}</span>
          </span>
        </Link>
      ))}
    </div>
  );
}